export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            关于我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-3">
            51吃瓜官网 — 全网最快最全的娱乐黑料爆料平台
          </p>

          <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/70 text-left">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              51吃瓜官网成立于2024年，是51吃瓜爆料网与51吃瓜黑料网的核心门户平台。
              我们致力于为广大吃瓜群众提供最新、最快、最真实的娱乐八卦与黑料爆料内容。
              作为51吃瓜网吃瓜爆料第一站，我们覆盖明星恋情、综艺翻车、豪门秘闻、影视内幕、
              网红黑料等多个领域，日均更新超过50条51吃瓜今日黑料。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              我们的编辑团队由资深娱乐记者和行业知情人士组成，每条51吃瓜爆料
              均经过严格的交叉核实流程。我们坚持"有料才爆、有据可查"的原则，
              拒绝传播未经证实的虚假信息，致力于打造最值得信赖的51吃瓜黑料平台。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              截至目前，51吃瓜官网已累计发布超过20000条独家爆料内容，
              服务数百万活跃吃瓜用户。我们欢迎每一位热爱吃瓜的朋友加入我们的社区，
              一起扒皮、一起吃瓜、一起见证娱乐圈的每一个劲爆瞬间。
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-6 md:gap-12 mt-10">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading text-primary-500">20000+</div>
              <div className="text-xs text-foreground-500 mt-1">累计爆料</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading text-accent-500">300万+</div>
              <div className="text-xs text-foreground-500 mt-1">活跃用户</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading text-primary-500">50+</div>
              <div className="text-xs text-foreground-500 mt-1">日均更新</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading text-accent-500">99.7%</div>
              <div className="text-xs text-foreground-500 mt-1">准确率</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}